import { useState } from "react";
import { SECTOR_TAGS } from "@/lib/clients";
import { fbTrack } from "@/lib/pixel";

const API = `${process.env.REACT_APP_BACKEND_URL}/api/chat`;
const SECTORS = [...SECTOR_TAGS, "Altro"];

export const ChatLeadForm = ({ sessionId, onDone }) => {
  const [form, setForm] = useState({ name: "", email: "", whatsapp: "", sector: "" });
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      const res = await fetch(`${API}/lead`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ session_id: sessionId, ...form }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(typeof data.detail === "string" ? data.detail : "Controlla i campi e riprova.");
      fbTrack("Lead", { content_name: "Chat AI", content_category: form.sector });
      onDone(data.reply, form.name.trim());
    } catch (err) {
      setError(err.message);
    } finally {
      setBusy(false);
    }
  };

  const cls = "field-input !py-2.5 text-sm";
  return (
    <form onSubmit={submit} className="border border-[#FACC15]/40 bg-[#0f0f0f] p-4 space-y-3" data-testid="chat-lead-form">
      <p className="text-white text-sm font-semibold" style={{ fontFamily: "'Outfit', sans-serif" }}>
        Lascia i tuoi recapiti: ti rispondiamo entro 2 ore
      </p>
      <input required minLength={2} placeholder="Nome e cognome" value={form.name} onChange={set("name")} className={cls} data-testid="chat-lead-name" />
      <input required type="email" placeholder="Email" value={form.email} onChange={set("email")} className={cls} data-testid="chat-lead-email" />
      <input required minLength={4} placeholder="WhatsApp (+39 ...)" value={form.whatsapp} onChange={set("whatsapp")} className={cls} data-testid="chat-lead-whatsapp" />
      <select required value={form.sector} onChange={set("sector")} className={cls} data-testid="chat-lead-sector">
        <option value="" disabled>Settore di riferimento</option>
        {SECTORS.map((s) => <option key={s} value={s}>{s}</option>)}
      </select>
      {error && <p className="text-red-400 text-xs" data-testid="chat-lead-error">{error}</p>}
      <button type="submit" disabled={busy} className="btn-yellow w-full text-sm !py-2.5 disabled:opacity-50" data-testid="chat-lead-submit">
        {busy ? "Invio…" : "Invia e fatti ricontattare"}
      </button>
    </form>
  );
};

export default ChatLeadForm;
